module.exports = __webpack_public_path__ + "static/harrisons-solar-54e908a2a80dbdc5f6a8a388997473d3.webp";